import React from "react";
import List from "./List";
import "./tab-filter.scss";

export default function(props) {
  return <List {...props} />;
}
